import JSEncrypt from 'jsencrypt'
// eslint-disable-next-line import/no-unresolved
import publicKey from '@/assets/key/rsa_public_key'
// eslint-disable-next-line import/no-unresolved
import privateKey from '@/assets/key/rsa_private_key'

/* eslint-disable func-names */
export const autoTableHight = (height) => document.body.clientHeight - 40 - 16 - height
export const formatDate = (date) => {
  const d = new Date(date)
  let month = `${d.getMonth() + 1}`
  let day = `${d.getDate()}`
  const year = d.getFullYear()

  if (month.length < 2) month = `0${month}`
  if (day.length < 2) day = `0${day}`

  return [year, month, day].join('-')
}

export const init = () => {
  // eslint-disable-next-line no-extend-native
  Date.prototype.format = function (fmt) {
    const o = {
      'M+': this.getMonth() + 1, // 月份
      'd+': this.getDate(), // 日
      'h+': this.getHours() % 12 === 0 ? 12 : this.getHours() % 12, // 小时
      'H+': this.getHours(), // 小时
      'm+': this.getMinutes(), // 分
      's+': this.getSeconds(), // 秒
      'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
      S: this.getMilliseconds() // 毫秒
    }
    // eslint-disable-next-line no-param-reassign
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, `${this.getFullYear()}`.substr(4 - RegExp.$1.length))
    // eslint-disable-next-line no-restricted-syntax
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        // eslint-disable-next-line no-param-reassign
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length))
      }
    }
    return fmt
  }
}

export const encryptFunc = (params) => {
  const jse = new JSEncrypt()
  if (params) {
    params = JSON.stringify(params)
  }
  jse.setPublicKey(publicKey)

  const data = jse.encrypt(params) // 进行加密
  return data
}

export const decryptFunc = (params) => {
  const jse = new JSEncrypt()

  console.log(params)
  jse.setPrivateKey(privateKey)
  let data = jse.decrypt(params)
  if (data && data.length > 3) {
    data = JSON.parse(data)
  }
  return data
}
export default {
  autoTableHight,
  formatDate,
  init
}
